export default __webpack_public_path__ + "static/media/germ_novice_badge_small@3x.fb538232.png";